import { ChangeDetectionStrategy, Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { UnaryFunction } from '@dice/app/types/dice.types';
import { FlyOutMenuButton } from '@dice/app/types/search-bar.types';

@Component({
  selector: 'table-column-flyout-menu',
  templateUrl: './table-column-flyout-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnFlyoutMenuComponent<T> {
  @ViewChild('sdxMenuFlyoutElement') sdxMenuFlyout;

  @Input() element: T;

  @Input() onClick: UnaryFunction<T>;

  @Input() iconName: string | UnaryFunction<T, string>;

  @Input() buttons: FlyOutMenuButton[] = [];

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  @Input() tooltip?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = false;

  displayedToggleIcon: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    const { iconName } = changes;
    if (iconName) {
      this.displayedToggleIcon = this.getIcon();
    }
  }

  ngAfterViewInit(): void {
    this.closeFlyOutMenu();
  }

  private getIcon(): string {
    if (typeof this.iconName === 'string') {
      return this.iconName;
    }
    return this.iconName(this.element);
  }

  private closeFlyOutMenu(): void {
    this.sdxMenuFlyout.nativeElement.close();
  }

  click($event): void {
    $event.stopPropagation();
    if (this.onClick) {
      this.onClick(this.element);
    }
  }
}
